import * as React from 'react';
import {
    Card, CardContent, Typography, Divider,
} from '@mui/material';
import Pagination from '@mui/material/Pagination'
import { formatDateNoHour, formatHour } from '../../../utilities/generalUtils'
import { UserSessionsApi } from '../../../apis/UserSessionsApi'
import TieredPricingModal from './TieredPricingModal'

const PAGE_SIZE = 7

function GuestChargingHistory() {
    const [sessions, setSessions] = React.useState([])
    const [page, setPage] = React.useState(1)
    const [pages, setPages] = React.useState(1)
    const [hasNext, setHasNext] = React.useState(false)
    const [selectedSession, setSelectedSession] = React.useState(null)

    const fmtUSD = React.useMemo(
        () => new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }),
        []
    )

    const loadPage = (p) => {
        UserSessionsApi.get(p, PAGE_SIZE).then((data) => {
            setSessions(data.items || [])
            setPage(data.page)
            setPages(data.pages)
            setHasNext(data.hasNext)
        }).catch(() => {})
    }

    React.useEffect(() => {
        loadPage(1)
    }, [])

    return (
        <>
        <TieredPricingModal session={selectedSession} onClose={() => setSelectedSession(null)} />
        <Card elevation={0} sx={{ overflow: 'hidden' }}>
            <CardContent sx={{ pb: 0 }}>
                <Typography variant="h6" fontWeight={700} sx={{ mb: 1.5 }}>
                    Charging History
                </Typography>

                {sessions.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 2, fontSize: 14 }}>
                        No history available
                    </Typography>
                ) : (
                    <>
                        {sessions.map((row, idx) => {
                            const s = row.session || {}
                            const h = s?.duration?.hours ?? 0
                            const m = s?.duration?.minutes ?? 0
                            const energy = s?.powerConsumedInKwh
                                ? `${s.powerConsumedInKwh.power}${s.powerConsumedInKwh.unit}`
                                : '0kWh'
                            const cost = s?.chargingCost != null ? fmtUSD.format(s.chargingCost) : null

                            return (
                                <React.Fragment key={s?.uuid || idx}>
                                    <div
                                        style={{ padding: '10px 0', cursor: 'pointer' }}
                                        onClick={() => setSelectedSession(row)}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                            <Typography variant="body1" sx={{ fontSize: '1.2rem' }} color="text.secondary">
                                                {formatDateNoHour(s?.startedAt)}
                                            </Typography>
                                            <Typography variant="body1" sx={{ fontSize: '1.2rem' }} color="text.secondary">
                                                {formatHour(s?.startedAt)}
                                            </Typography>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="body1" sx={{ fontSize: '1.3rem' }} color="text.primary">{h}h {m}m</Typography>
                                            <Typography variant="body1" sx={{ fontSize: '1.3rem' }} color="text.primary">{energy}</Typography>
                                            {cost && <Typography variant="body1" sx={{ fontSize: '1.3rem', fontWeight: '600' }} color="text.primary">{cost}</Typography>}
                                        </div>
                                        {s?.chargingCost != null && Math.round(s.chargingCost * 100) > 0 && s.chargingCost < 0.5 && (
                                            <Typography variant="body2" sx={{ fontSize: '1rem', fontStyle: 'italic', mt: 0.5 }} color="text.primary">
                                                No amount charged to your payment method.
                                            </Typography>
                                        )}
                                    </div>
                                    {idx < sessions.length - 1 && <Divider />}
                                </React.Fragment>
                            )
                        })}
                        {pages > 1 && (
                            <Pagination
                                shape="rounded"
                                size="small"
                                count={pages}
                                page={page}
                                onChange={(_, p) => loadPage(p)}
                                defaultPage={1}
                                boundaryCount={1}
                                siblingCount={0}
                                sx={{
                                    mt: 1.5,
                                    mb: 0.5,
                                    '& .MuiPagination-ul': {
                                        justifyContent: 'space-between',
                                        flexWrap: 'wrap',
                                    },
                                    '& .MuiPaginationItem-root': {
                                        mx: 0.5
                                    },
                                    '& .MuiPaginationItem-previousNext': {
                                        mx: 0,
                                        px: 0,
                                        minWidth: 'auto'
                                    },
                                }}
                            />
                        )}
                    </>
                )}
            </CardContent>
        </Card>
        </>
    )
}

export default GuestChargingHistory;
